import React, { useCallback, useRef } from 'react';
import { UserComponent } from 'react/UserComponent.jsx';
import { Dashboard } from 'components/Dashboard.jsx';
import { LocationComponent } from 'react/LocationComponent.jsx';
import { OnlineIndicator } from 'react/OnlineIndicator.jsx';
import useWavesEffect from "../../hooks/useWavesEffect";
import withDefaultProps from 'functions/withDefaultProps';

export default function UserUserlistComponent(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const ref = useRef(null);
	const wavesClasses = useWavesEffect(ref);
	const onUsernameClick = useCallback((e) => {
		const { onClick } = props;
		if(onClick) {
			onClick(props.user, e);
		}
		else {
			e.stopPropagation();
			Dashboard.UserInfo.loadProfile(props.user, {
				x: e.nativeEvent.x,
				y: e.nativeEvent.y
			});
		}
	}, [props.user, props.onClick]);

	const { user, style, isChatMod, showLocation, locationExtra } = props;
	if(!user) {
		return null;
	}

	return (
		<div
			ref={ref}
			onClick={onUsernameClick}
			style={style}
			className={`online_user unclickable ${wavesClasses.toString()} ${user.isOnline() ? 'is_online' : 'is_offline'}`}>
			<div className='user_facts'>
				<div className='online_indicator_and_such'>
					<OnlineIndicator player={user} />
					<UserComponent
						unclickable={true}
						user={user}
						isChatMod={isChatMod}
						showTopDonatorFlair={true}
					/>
				</div>
				{showLocation &&
				<div className='user_location'>
					<LocationComponent
						location={user.location}
						otherLocation={myUser.location}
					/>
					{locationExtra}
				</div>
				}
			</div>
		</div>
	);
}
const defaultProps = {
	showLocation: true,
};